import styled from 'styled-components'

export const TopHeader = styled.div`
  display: flex;
  justify-content: space-between;
  max-width: 1411px;
  margin: 0 auto;
  padding: 10px 0px;
  @media (max-width: 767px){
    display: block;
  }
  h6{
    font-size: 19px;
    font-weight: bold;
    align-self: center;
  }
  @media (max-width: 1250px) {
    padding: 9px 13px;
  }
  .top-header-container{
    display: flex;
    z-index: 3;
    .main-location-wrapper{
      width: 250px;
      border: 1px solid #87cdf1;
      z-index: 3;
    }
    .sub-location-wrapper{
      width: 200px;
      border: 1px solid #87cdf1;
      z-index: 2;
      border-radius: 5px;
      margin-left: 20px;
    }
  }
  @media (max-width: 767px){
    .top-header-container{
      width: 100%;
      margin-top:20px;
      .main-location-wrapper{
        width: 250px;
        border: 1px solid #87cdf1;
        z-index: 3;
      }
      .sub-location-wrapper{
        width: 200px;
        border: 1px solid #87cdf1;
        z-index: 2;
        border-radius: 5px;
        margin-left: 20px;
      }
    }
  }
`

export const Container = styled.div`
  /* max-width: 1411px; */
  padding: 0 0 28px 0;
  width: 100%;
  margin: 0 auto;
  display: block;
  .MuiAppBar-colorPrimary {
    background-color: transparent;
    box-shadow: none;
    padding-bottom: 25px;
  }
  .MuiTab-textColorInherit.Mui-selected {
    color: #0a1f30;
    font-family: "latobold" !important;
  }
  .MuiTab-textColorInherit {
    color: #7a7a7a;
    opacity: 1;
    text-transform: capitalize;
    font-size: 16px;
    font-family: "latomedium" !important;
  }
  .MuiTabs-indicator {
    background-color: #2fb5f1;
    height: 4px;
  }
  .MuiBox-root {
    padding: 0;
  }
  .MuiTab-wrapper{
    flex-direction: row;
    gap: 8px;
    align-items: center;
  }
  .notification {
    color: #ffffff;
    background-color: #3fb144;
    padding: 2px;
    border-radius: 50%;
    height: 24px;
    min-width: 24px;
    top: 44px;
    right: 34px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
  }
`;

export const Wrapper = styled.div`
  position: relative;
  max-width: 1411px;
  margin: 0 auto;
  top: -55px;
  .MuiAppBar-colorPrimary{
    padding-bottom: 15px;
  }
  > div {
    flex: 1;
  }
  @media (max-width: 1400px) {
    top: 0px;
  }
  @media (max-width: 1250px) {
    padding: 0 15px;
  }
  @media (max-width: 500px) {
    top: 0px;
  }
`

export const FilterWrapper = styled.div`
    display: flex;
    justify-content: end;
    margin: 10px auto;
    max-width: 1411px;
    padding: 10px 0;
    min-height: 49px;   
    .basic-multi-select{
      > div {
        min-height: 41px;
      }
    }
    .export-csv-style{
      button{
        background: linear-gradient(rgb(97, 176, 31) 0%, rgb(39, 145, 27) 100%);
        color: white;
        border: 0;
        border-radius: 5px;
        padding: 5px 15px;
        margin: 5px;
        position: relative;
        z-index: 2;
      }
    }
    @media (max-width: 1250px) {
      padding: 9px 10px 0px 10px;
    }
    .post-filter-wrapper{
      width: 200px;
      border-radius: 5px;
      z-index: 2;
      margin-left: 5px;
    }
    .check-box-class{
      z-index: 2;
    }
    @media (max-width: 767px){
      display: block;
      width: 100%;
      .post-filter-wrapper{
        margin-left: 0;
      }
    }
`
export const SearchWrapper = styled.div`
    display: flex;
    position: relative;
    border-radius: 4.2px;
    overflow: auto;
    width: 220px;
    z-index: 1;
    max-height: 41px;
    @media (max-width: 767px){
      margin: 10px 0;
    }
    input {
      background: #ffffff;
      border: 1px solid #DADADF;
      padding: 4px 35px 4px 15px;
      border-radius: 5px;
      ::-webkit-input-placeholder { /* Edge */
      color: #00000087;
      }

      :-ms-input-placeholder { /* Internet Explorer 10-11 */
        color: #00000087;
      }

      ::placeholder {
        color: #00000087;
      }
    }
    svg {
      position: absolute;
      right: 10px;
      top: 10px;
      color: #525e66;
      width: 21px;
      height: 21px;
    }
    margin: 0 4px;
`

export const DateWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  z-index: 1;
  max-height: 41px;
  .date-style-class{
    .custom-date-piker{
      width: 170px;
    }
  }
  .file-input-wrapper{
    width: 190px;
  }
  .MuiFormControl-root {
    height: 40px;
    border: solid 1px #DADADF;
  } 
  > div {
    display: flex;
    p {
      margin: 12px;
    }
  }
  .dropDown {
    width: 200px;
  }
  label {
    padding: 5px;
    margin: 2px 0 0;
    font-size: 18px;
  }
  @media (max-width: 767px){
      margin: 10px 0;
  }
  @media (max-width: 650px) {
    > div {
      flex-direction: row;
      p {
        margin: 5px;
      }
    }
  }
  @media (max-width: 500px){
    max-height: 150px;
    > div {
      flex-direction: column;
    }  
  }
`;

export const TableWrapper = styled.div`
  max-width: 1411px;

  > div {
    border-radius: 10px;
    box-shadow: 0 2px 10px 0 rgb(0 0 0 / 16%);
    padding: 18px 10px;
    @media (max-width: 767px) {
      padding: 15px;
      overflow: hidden;
    }
  }
`;

export const TableSection = styled.div`
    padding: 0px 12px;
    overflow: auto;
    .table-responsive{
        min-height: 124px;
    }
    &.pending-request{
      min-height:260px;
      tbody{
      tr:first-child,tr:nth-child(2),tr:nth-child(3){
        .action-popups{
          top: 47px;
          bottom: unset;
        .top-arrow{
          top: -16px;
            bottom: unset;
            transform: rotate(45deg);
          }
        }        
        }
      }
      .table-header{
        th{
          text-align: left;
        }
      }
      .create-order-button-styles{
        background: linear-gradient(90deg, #55C416 0%, #367910 100%);
        border: none;
        width: max-content;
        height: 26px;
        color: #fff;
        border-radius: 5px;
        padding: 3px 10px;
        font-size: 12px;
      }
    }
    .table thead th,.table td, .table th {
        border: none;
        font-size: 14px;
    }
    .table tbody tr:nth-child(odd) {
        // background-color:#fbfbfb;
    }
    thead{
      background: #ECECEC;
      th{
        text-align: left;
      }
    }
    tbody {
        position: relative;
        .blue-bg{
          background: #DFEDF5;
        }
    }
    .expand-collapse-class{
        display: flex;
        justify-content: end;
        h4{
            background: #005586;
            padding: 0px;
            width: 17px;
            border-radius: 50%;
            height: 16px;
            margin: 3px 0px 0px 11px;
            cursor: pointer;
            i {
                border: solid #ffff;
                border-width: 0 2px 2px 0;
                display: inline-block;
                padding: 2px;
                margin: 0px 0px 13px 6px;
                transform: rotate(-135deg);
                -webkit-transform: rotate(-135deg);
            }
        }  
        h5{
            background: #005586;
            padding: 0px;
            width: 16px;
            border-radius: 50%;
            height: 16px;
            margin: 3px 0px 0px 11px;
            cursor: pointer;
            i {
                border: solid #ffff;
                border-width: 0 2px 2px 0;
                display: inline-block;
                padding: 2px;
                margin: 0px 0px 13px 5px;
                transform: rotate(45deg);
                -webkit-transform: rotate(45deg);
            }
        }
        .status-class{
          padding: 0px 0px 0px 3px;
          border-radius: 4px;
          min-width: 119px;
          display: flex;
          cursor: pointer;
          justify-content: space-evenly;
          p{
            font-size: 12px;
          }
          span{
            padding: 0px 0px 0px 6px;
            font-size: 22px;
          }
        }
        .REQUESTED{
          background: #005586;
          color: #fff;
        }
        .POSTED{
          background: #005586;
          color: #fff;
        }
        .PENDING{
          background: linear-gradient(90deg, #55C416 0%, #367910 144.97%);
          color: #fff;
        }
        .ASSIGNED{
          background: #68A107;
          color: #fff;
        }
        .SHIPPED{
          background: #68A107;
          color: #fff;
        }
        .RESCHEDULED{
          color: green;
          background-color: yellow;
        }
        .DELIVERED{
          background: #68A107;
          color: #fff;
        }
        .PICKEDUP{
          background: linear-gradient(90deg, #55C416 0%, #367910 144.97%);
          color: #fff;
        }
        .COMPLETE{
          background: #000000;
          color: #fff;
        }
        .CANCELLED, .CLAIM{
          background: #ff000042;
          color: #ff0000;
        }
        .HOLD{
          color: green;
          background-color: yellow;
        }
        .EXPIRED{
          background: #ff0018f7;
          color: #fff;
        }
        .withdraw-action-btn{
          background: none;
          height: 34px;
          width: 28px;
          margin-right: 10px;
          border: none;
          border-radius: 5px;
          font-size: 12px;
          img{
            height: 18px;
            width: 18px;
          }
        }
    }
    .spec-count-style{
      position: absolute;
      top: -10px;
      right: -4px;
      font-size: 9px;
      background: #E7E7E7;
      border-radius: 50%;
      width: 14px;
      text-align: center;
    }
    .order-details-wrapper{
      background: #DFEDF5;
        td{
            border: none;
        }
        h6{
            font-size: 13px;
            font-weight: bold;
        }
        p{
            font-size: 14px;
        }
        .print-tag-style{
            border: 1px solid #E5E5E5;
            padding: 3px 10px 4px;
            white-space:nowrap;
            border-radius: 3px;
            background: #fff;
        }
    }
    tbody{
      /* tr:last-child,tr:nth-last-child(2){ */
      tr:last-child,tr:nth-child(9),tr:nth-child(8),tr:nth-child(7){
        .action-popups{
          top:unset;
          bottom: 47px;
.top-arrow{
  top: unset;
    bottom: -16px;
    transform: rotate(220deg);
}
        }
        
      }
    }
    .action-popups{
      position: absolute;
      display: grid;
      width: 350px;
      border: 1px solid #DADADA;
      border-radius: 5px;
      padding: 5px 25px 5px 25px;
      top: 47px;
      right: 10px;
      background: #fff;
      z-index: 1;
      margin-bottom: 2px;    
      /* max-height: 200px;
      overflow: auto; */
      div{
          display: flex;
          cursor: pointer;
      }
      span{
          margin: 10px;
      }
      .top-arrow{
          position: absolute;
          width: 15px;
          height: 15px;
          background: #ffff;
          border: solid #DADADA;
          border-width: 1px 0 0 1px;
          transform: rotate(45deg);
          top: -16px;
          right: 9px;
      }
    }
    .align-top{
      top : -250px;
      .top-arrow{
          top : 221px;
          transform: rotate(225deg);
      }
    }
    .log-content-styles{
      margin-top: 10px;
      p{
        margin: 5px 0 0 0;
      }
    }
    @media (max-width: 767px) {
        max-width:100%;
        overflow:auto;
    }
  
`
export const RequestTenderModalWrapper = styled.div`
    .modal-content {
        border-radius: 15px !important;
        overflow: hidden !important;
    } 
`

export const RequestTenderModalContentWrapper = styled.div`
  .date-picker-style{
    display: flex;
    svg{
      margin: 4px 8px 4px -2px;
    }
  }
  .app-timer-style{
    svg{
      margin: 4px 4px 6px -1px;
    }
    span{
      margin: 0 10px;
    }
  }
  .modal-body{
    padding: 0px;
  }
  .header{
    display: flex;
    align-items: center;
    padding: 15px;
    background: #005586;
    h4{
      flex: 1;
      text-align: center;
      color: #fff;
      font-size: 20px;
    }
    img{
      height: 18px;
      width: 18px;
      filter: brightness(0) invert(1);
      cursor: pointer;
    }
  }
  .details-wrapper {
      background-color: #fff;
      padding: 30px;
      border-radius: 10px;
      h4 {
          margin-bottom: 20px;
          font-size: 15px;
          font-weight: bold;
      }
      .first-row{
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        margin-right: 30px;
        margin-bottom: 15px;
        gap: 20px;
        h6{
          font-weight: bold;
          font-size: 13px;
        }
        p{
          font-size: 13px;
        }
      }
      .first-row-delivery-tender{
        display: grid;
        grid-template-columns: 1fr 1fr 1fr 1fr;
      }
      .second-row{
        display: flex;
        flex-wrap: wrap;
        gap: 20px;
        margin-right: 30px;
        margin-bottom: 15px;
        h6{
          font-weight: bold;
          font-size: 13px;
          color: #005586;
          margin-bottom: 8px;
        }
        p{
          font-size: 13px;
          margin-bottom: 15px;
        }
      }
      .buyer-comment{
        display: flex;
        margin-bottom: 15px;
        align-items: baseline;
        font-size: 13px;
        word-break: break-all;
        h6{
          font-weight: bold;
          font-size: 13px;
          color: #005586;
          margin-right: 5px;
          white-space: nowrap;
        }
      }
      .third-row{
        margin-bottom: 30px;
        h6{
          font-weight: bold;
          font-size: 13px;
          color: #005586;
        }
        .text-area{
          border: 1px solid #e5e5e5;
          margin-top: 10px;
          padding: 5px 10px;
          font-size: 12px;
          border-radius: 5px;
          min-height: 75px;
          word-wrap: break-word;
          width: 100%;
          resize: none;
        }
      }
      .payment-section-styles{
        margin-bottom: 20px;
        .payment-section-wrapper{
          border: 1px solid #e3e3e3;
          padding: 20px;
        }
        .ach-backup-section-styles{
          margin-bottom: 15px;
          max-width: 500px;
          .css-yk16xz-control{
            border-color: #87cdf1;
          }
        }
        .radio-button-styles {
          appearance: auto;
          -webkit-appearance: auto;
          -moz-appearance: auto;
          position: relative;
          width: 22px;
          height: 22px;
          border: 2px solid #87cdf1; /* Outer circle color */
          border-radius: 50%;
          cursor: pointer;
          margin-right: 10px;
        }
        .radio-button-styles:checked::before {
          content: '';
          position: absolute;
          top: 50%;
          left: 50%;
          width: 12px;
          height: 12px;
          background-color: #87cdf1; /* Inner dot color */
          border-radius: 50%;
          transform: translate(-50%, -50%);
        }
      }
      .acknowledge-section-style input[type="checkbox"] {
          width: 22px;
          height: 22px;
          margin-right: 8px;
          appearance: none;
          -webkit-appearance: none;
          background-color: #fff;
          border: 2px solid #4CAF50;
          border-radius: 3px;
          position: relative;
          cursor: pointer;
          outline: none;
          transition: background-color 0.2s, border-color 0.2s;
      }

      .acknowledge-section-style input[type="checkbox"]:checked {
          background-color: #4CAF50;
          border-color: #4CAF50;
      }

      .acknowledge-section-style input[type="checkbox"]:checked::before {
          content: '✔';
          font-size: 16px;
          color: white;
          position: absolute;
          left: 2px;
          top: -3px;
      }

      .acknowledge-section-style label {
          display: flex;
          align-items: center;
          font-size: 14px;
          color: #333;
          margin-right: 10px;
      }
      .button-wrapper{
        text-align:center;
        button{
          background: linear-gradient(90deg, #55C416 0%, #367910 100%);
          color: #fff;
          font-size: 13px;
          padding: 7px 30px;
          border: none;
          border-radius: 10px;
          cursor: pointer;
        }    
      }
      @media (max-width: 500px) {
        .first-row{
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 20px !important;
        }
      }
    }   
`

export const SelectWrapper = styled.div`
    width: 225px;
    border: 1px solid #87cdf1;
    border-radius: 5px;
    margin-bottom: 15px;
    .custom-select__single-value{
      font-size: 14px;
    }
    .custom-select__placeholder{
      font-size: 13px;
    }
    .custom-select__control{
      min-height: 32px !important;
      height: 32px !important;
    }
`